import { Component } from '@angular/core';
import { CustomErrorHandler } from '@questrade/flx-commons';
import { DeveloperProvider } from '../../../providers/developers';
import { IonicPage } from 'ionic-angular/navigation/ionic-page';
import { NavController, NavParams, Events } from 'ionic-angular';

@IonicPage({
  name: 'sdk-javascript',
  segment: 'sdk-javascript',
  defaultHistory: ['home']
})
@Component({
  selector: 'page-sdk-javascript',
  templateUrl: 'sdk-javascript.html',
})
export class SdkJavascriptPage {
  docuData;
  public examplesCode: Object;

  constructor(
    public events: Events,
    public navCtrl: NavController,
    public navParams: NavParams,
    private devProvider: DeveloperProvider,
    private customErrorHandler: CustomErrorHandler) {
    this.events.publish('menu:changed', true, 'sdk-javascript');
    this.examplesCode = {
      import: `
                <!-- Import Flexiti SDK-->
                <script src="https://onlineapi-uat.flexiti.fi/public/libs/SDK/js/flexiti-sdk-0.0.1.js"></script>
            `,
      code1: `
                flxSdk = new FlexitiSDK({
                env: 'uat',
                clientID: 'client-id-from-developer-account-section',
                clientSecret: 'client-secret-from-developer-account-section',
                });
            `,
      code2: `
                flxSdk.OAuthInit({
                    amountRequested: 1233,
                    customer: {
                    fname: 'John',
                    lname: 'Doe',
                    has_previous_purchase: true, // this means is a new user in your site or not
                    is_guest: false, // true if the customer is purchasing with a guest account
                    dob: '01-01-1990',
                    postal_code: 'm1m1m1',
                    lang: '',
                    salutation: ''
                    }
                });
                `,
      code3: `
                //OauthInit method response:
                {
                    "online_order_id": 100116,
                    "redirection_url": "https://onlineapi.flexiti.fi/#/flexitidemo/9e0ce9d7f20ed746f87fb1756fd2194fb5bf08b1"
                }
                `,
      code4: `
                flxSdk.simpleRenderButton({
                iframeContainer: '#iframe-flexiti',
                querySelector: '#flexiti-button',
                amountRequested: 2000
                });
            `
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/sdk/sdk-javascript/sdk-javascript.ts